// src/mocks/handlers/operations.handlers.js
import * as data from '../data/operations.demo';

export const start = async () => ({ success: true, data: data.currentOperation });
export const getCurrent = async () => ({ success: true, data: data.currentOperation });
export const getMovements = async () => ({ success: true, data: data.currentMovements });
export const withdrawal = async () => ({ success: true });
export const deposit = async () => ({ success: true });
export const movement = async () => ({ success: true });
export const getClosingSummary = async () => ({ success: true, data: data.closingSummary });
export const close = async () => ({ success: true });
export const getReport = async () => ({ success: true, data: data.operationReport });
export const handle = async () => ({ success: true, data: data.operationList });
